import axios, { AxiosInstance } from 'axios';
import md5 from 'md5';
import { defaultGetErrorMsg, getXUa, showError, showMessage } from '@/utils';
import _get from 'lodash/get';

/**
 * 开发环境不设置 baseURL，让请求走 Vite 代理（避免 CORS）
 * 生产及其他环境使用 VITE_APP_URL
 */
const isDev = import.meta.env.VITE_APP_ENV === 'dev';

const CONFIG = {
  baseURL: isDev ? '' : import.meta.env.VITE_APP_URL || '',
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  },
};

const axiosInstance: AxiosInstance = axios.create(CONFIG);

axiosInstance.interceptors.request.use(
  (config) => {
    // 配置公共的请求部分逻辑
    if (!config.headers) {
      return config;
    }
    const token =
      localStorage
        .getItem(`JOY_ADMIN_${import.meta.env.VITE_APP_ENV}_TOKEN`)
        ?.replaceAll('"', '') || '';
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers['content-type'] = 'application/json';
    config.headers['x-mock-disable-signature'] = true;
    config.headers['X-UA'] = getXUa();

    // const sign = md5(
    //   Object.keys(params)
    //     .sort()
    //     .map((key) => `${key}=${params[key]}`)
    //     .join("&") + clientMap[realRegion].clientSecret
    // )

    return config;
  },
  (error) => {
    throw error;
  }
);

const UNAUTHENTICATED_CODES = new Set([10001, 10002, 10003, 10004]);

const logoutAndRedirect = () => {
  const env = import.meta.env.VITE_APP_ENV;
  axiosInstance.post('/api/user/v1/logout').finally(() => {
    localStorage.setItem(`JOY_ADMIN_${env}_TOKEN`, '""');
    localStorage.setItem(`JOY_ADMIN_${env}_USER_INFO`, '""');
    window.location.href = `/login?redirect=${window.location.pathname}${window.location.search}`;
  });
};

// Add a response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    const code: number = response.data?.code;
    if (UNAUTHENTICATED_CODES.has(code)) {
      const errMsg = response.data?.message || 'Unauthenticated';
      showError(errMsg, 2);
      setTimeout(() => {
        logoutAndRedirect();
      }, 2000);
      return Promise.reject(new Error(errMsg));
    }
    const res = response.data.data;
    return Promise.resolve(res);
  },
  (error) => {
    const status = _get(error, 'response.status');
    const headers = error?.config?.headers;
    const hideErrorMessage = headers?.showErrorMessage === false; // 默认显示错误信息
    const responseCode: number = _get(error, 'response.data.code', 0);
    // 嵌套在 data.data 中的业务错误码（如 40002 密码过期），由调用方自行处理提示
    const nestedCode: number = _get(error, 'response.data.data.code', 0);
    const CALLER_HANDLED_CODES = new Set([40002]);

    if (status === 401 || UNAUTHENTICATED_CODES.has(responseCode)) {
      if (!hideErrorMessage) {
        showError(defaultGetErrorMsg(error), 2);
      }
      setTimeout(() => {
        logoutAndRedirect();
      }, 2000);
    } else if (CALLER_HANDLED_CODES.has(nestedCode)) {
      // 由业务层自行展示提示，此处不弹 toast
    } else {
      if (!hideErrorMessage) {
        showError(defaultGetErrorMsg(error));
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
